import { observer } from 'mobx-react'
import React, { ReactElement } from 'react'
import Modal, { ModalProps } from './Modal'
import { IconButton } from './Button'
import Close from '../icons/Close'
import { RADOM_COLORS } from '../util/Constants'
import Copy from '../icons/Copy'
import { errorToast, successToast } from '../util/Util'
import Dropdown, { DropdownItem } from './Dropdown'
import NewDots from '../icons/NewDots'
import ConfirmButtonModal from './ConfirmButtonModal'

interface VirtualAccountDetailsModalProps extends ModalProps {
  subtitle: string
  subtitleIcon: string
  items: Array<{ title: string, value: string, isCopy: boolean }>
  onAccountDelete: () => void
}

const VirtualAccountDetailsModal = observer(({
  onClose,
  title,
  visible,
  subtitle,
  subtitleIcon,
  items,
  onAccountDelete
}: VirtualAccountDetailsModalProps): ReactElement => {
  return <Modal visible={visible} onClose={onClose} innerStyles={{ width: 450, borderRadius: 16, padding: 0 }}>
    <div style={{
      padding: 24,
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        zIndex: 1,
        position: 'sticky',
        top: 0,
        backgroundColor: RADOM_COLORS.WHITE,
        paddingTop: 5,
        paddingBottom: 5
      }}>
        <span style={{ fontSize: 18, fontWeight: 500 }}>{title}</span>
        <IconButton type='button' onClick={ onClose} style={{ padding: 0 }}>
          <Close style={{ width: '14px' }} />
        </IconButton>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
          <img
            style={{
              width: 26,
              height: 26
            }}
            src={subtitleIcon}
          />
          <span style={{ fontSize: '14px', color: RADOM_COLORS.BLACK }}>{subtitle}</span>
        </div>
        <Dropdown
          noChevron
          selectedContent={<NewDots width={20}/>}
          dropdownContent={
            <div style={{ fontSize: 14, whiteSpace: 'nowrap' }}>
              <ConfirmButtonModal
                title='Delete account'
                description='Are you sure you want to delete this account?'
                action='Delete account'
                onConfirm={onAccountDelete}
                ActionComponent={(props: any) => <DropdownItem {...props}>Delete account</DropdownItem>}
              />
            </div>
          }
        />
      </div>
      <div style={{
        padding: 18,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        borderRadius: 14,
        backgroundColor: RADOM_COLORS.GRAY9
      }}>
        {items.map((item, idx) => <div key={idx} style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: 6
        }}>
          <span style={{ color: RADOM_COLORS.GRAY4, fontSize: 12 }}>
            {item.title}
          </span>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between'
          }}>
            <span style={{ color: RADOM_COLORS.RADOM_BLUE, fontSize: 12 }}>
              {item.value}
            </span>
            {item.isCopy &&
            <IconButton style={{ padding: 0 }}>
              <Copy style={{ width: 16, stroke: RADOM_COLORS.RADOM_BLUE }} onClick={(e) => {
                e.stopPropagation()
                navigator.clipboard
                  .writeText(item.value)
                  .then(() => {
                    successToast(
                      `Copied ${item.title}`
                    )
                  })
                  .catch((err) => {
                    console.error('copy failed', err)
                    errorToast(
                      `Failed to copy ${item.title}`
                    )
                  })
              }} />
            </IconButton>}
          </div>
        </div>)}
        <div style={{
          padding: 10,
          borderRadius: 4,
          backgroundColor: RADOM_COLORS.WHITE
        }}>
          <span style={{ color: RADOM_COLORS.RADOM_BLUE, fontSize: 12 }}>
            Please ensure you are sending funds on supported payment rails.
            Deposits made via other rails may result in permanent loss of funds.
          </span>
        </div>
      </div>
    </div>
  </Modal>
})

export default VirtualAccountDetailsModal
